'use client';

import { CampaignDetails } from './CampaignDetails';
import { AvailableRewards } from './AvailableRewards';
import { TransformedDapp } from '@/utils';
import { useDappInfo } from '@/hooks/dashboard';
import { EcosystemDapp } from '@/hooks/content';

const isTransformedDapp = (dapp: TransformedDapp | EcosystemDapp): dapp is TransformedDapp => {
  return 'rewardTokens' in dapp;
};

export const DappRewardsPoolDetails = ({
  dapp,
  dappMerklId,
}: {
  dapp: TransformedDapp | EcosystemDapp;
  dappMerklId?: number | string;
}) => {
  const { dappCampaignsInfo, campaignInfo } = useDappInfo({ dappMerklId });

  return (
    <div className="w-full flex flex-col items-center gap-4">
      {isTransformedDapp(dapp) && dapp?.rewardTokens && (
        <AvailableRewards tokens={dapp?.rewardTokens} dappCampaignsInfo={dappCampaignsInfo} />
      )}

      {!!campaignInfo?.length && <CampaignDetails campaigns={campaignInfo} />}
    </div>
  );
};
